import React from 'react';
import { NavLink } from 'react-router-dom';
import './AdminShell.css';

/** Two-game pill switcher, same as admin. */
function GameSwitch({ sections, ariaLabel = 'Игра' }) {
  return (
    <nav className="admin-switch" aria-label={ariaLabel}>
      {sections.map((s) => (
        <NavLink
          key={s.key}
          to={s.to}
          replace
          className={({ isActive }) => `admin-switch__tab${isActive ? ' active' : ''}`}
        >
          {s.label}
        </NavLink>
      ))}
    </nav>
  );
}

export default GameSwitch;
